/**
 * SmartLoanTenureInput
 *
 * Smart component that displays loan tenure in days.
 * User selects days (90, 180, 360), and backend converts to months/weeks based on repayment frequency.
 *
 * Component ID: LOS_SmartLoanTenureInput_439
 * Getter API: LOS_GetLoanTenure_440
 * Setter API: LOS_SetLoanTenure_441
 */

import React, { useCallback } from 'react';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface SmartLoanTenureInputProps {
  value?: {
    loan_tenure?: number | null;
    repayment_frequency?: string;
  };
  onChange?: (val: { loan_tenure: number }) => void;
  disabled?: boolean;
}

const SmartLoanTenureInput: React.FC<SmartLoanTenureInputProps> = ({
  value,
  onChange,
  disabled = true  // Always disabled - value comes from backend
}) => {
  // Get current tenure value from backend
  const currentValue = value?.loan_tenure || 180;

  const handleChange = useCallback((tenure: string) => {
    // Component is always disabled, don't trigger onChange
    return;
  }, []);

  const tenureOptions = [
    { value: 90, label: '90 days' },
    { value: 180, label: '180 days' },
    { value: 270, label: '270 days' },
    { value: 360, label: '360 days' }
  ];

  return (
    <div className="space-y-1.5">
      <Label htmlFor="loan_tenure" className="text-sm font-medium">
        Loan Tenure <span className="text-red-500">*</span>
      </Label>
      
      <Select value={currentValue?.toString()} onValueChange={handleChange} disabled={true}>
        <SelectTrigger id="loan_tenure" className="w-full text-intellend-green !font-semibold [&>span]:text-intellend-green [&>span]:!font-semibold disabled:text-intellend-green disabled:opacity-100 [&>span]:disabled:text-intellend-green">
          <SelectValue placeholder="Select tenure" />
        </SelectTrigger>
        <SelectContent>
          {tenureOptions.map((option) => (
            <SelectItem key={option.value} value={option.value.toString()}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default SmartLoanTenureInput;
